import React, { useState } from "react";
import lock from "../assets/images/lock.png";
import lock1 from "../assets/images/lock-img.png";
import { useDispatch } from "react-redux";
import { changePassword } from "../features/slices/authReducer";
import { Navigate, useNavigate } from "react-router-dom";
const initialState = {
  newPassword: "",
  password: "",
  errors: {},
  loading: false,
  eye: {
    passwordEye: false,
    confirmPasswordEye: false,
  },
};
const ChangePassword = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { password, newPassword, errors, loading, eye } = iState;
  const { passwordEye, confirmPasswordEye } = eye;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e?.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
      errors: {
        ...prev.errors,
        [e.target.name]: "",
      },
    }));
  };
  const handleCancel = () => {
    setUpdateState(initialState);
    navigate(-1);
  };
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!password?.trim()) {
      formErrors.password = "Old password is required.";
      isValid = false;
    }

    if (!newPassword?.trim()) {
      formErrors.newPassword = "New password is required.";
      isValid = false;
    } else if (newPassword.length < 8) {
      formErrors.newPassword =
        "New password must be at least 8 characters long.";
      isValid = false;
    }

    setUpdateState((prev) => ({
      ...prev,
      errors: formErrors,
    }));
    return isValid;
  };
 const handleChangePassword = () => {
   if (validateForm()) {
     const data = {
       password,
       newPassword,
     };
     dispatch(changePassword(data)).then((res) => {
       if (res?.payload?.code == 200) {
         navigate("/dashboard");
       }
     });
   }
 };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper" style={{ width: "75%" }}>
          <div className="TitleBox Border flex-column align-items-start">
            <h4 className="Title">Password</h4>
            <p>Give me correct password and change password</p>
          </div>
          <div className="row">
            <div className="col-lg-7">
              <div className="CommonForm">
                <div className="form-group">
                  <label>Old Password</label>
                  <div className="SearchBox">
                    <input
                      type={`${passwordEye ? "text" : "password"}`}
                      className="SearchInput"
                      placeholder="Enter Old Password"
                      name="password"
                      value={password}
                      onChange={handleChange}
                    />
                    <span className="Icon">
                      {!passwordEye ? (
                        <img src={lock} />
                      ) : (
                        <i className="fa fa-unlock-alt" aria-hidden="true" />
                      )}
                    </span>
                    <span
                      className="icon"
                      onClick={() => {
                        setUpdateState((prev) => ({
                          ...prev,
                          eye: {
                            passwordEye: !prev.eye.passwordEye,
                            confirmPasswordEye: prev.eye.confirmPasswordEye,
                          },
                        }));
                      }}
                    >
                      {!passwordEye ? (
                        <i className="fa fa-eye-slash" aria-hidden="true" />
                      ) : (
                        <i className="fa fa-eye" aria-hidden="true" />
                      )}
                    </span>
                  </div>
                  {errors.password && (
                    <p className="text-danger mt-2">{errors.password}</p>
                  )}
                </div>
                <div className="form-group">
                  <label>New Password</label>
                  <div className="SearchBox">
                    <input
                      type={`${confirmPasswordEye ? "text" : "password"}`}
                      className="SearchInput"
                      placeholder="Enter New Password"
                      name="newPassword"
                      value={newPassword}
                      onChange={handleChange}
                    />
                    <span className="Icon">
                      {!confirmPasswordEye ? (
                        <img src={lock} />
                      ) : (
                        <i className="fa fa-unlock-alt" aria-hidden="true" />
                      )}
                    </span>
                    <span
                      className="icon"
                      onClick={() => {
                        setUpdateState((prev) => ({
                          ...prev,
                          eye: {
                            passwordEye: prev.eye.passwordEye,
                            confirmPasswordEye: !prev.eye.confirmPasswordEye,
                          },
                        }));
                      }}
                    >
                      {!confirmPasswordEye ? (
                        <i className="fa fa-eye-slash" aria-hidden="true" />
                      ) : (
                        <i className="fa fa-eye" aria-hidden="true" />
                      )}
                    </span>
                  </div>
              {errors.newPassword && (
                <p className="text-danger mt-2">{errors.newPassword}</p>
              )}
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <figure className="text-center">
                <img src={lock1} />
              </figure>
            </div>
          </div>
          <button className="Button" onClick={handleChangePassword}>
            Save Details
          </button>
          <button className="Button Discard border-0" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
